import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=938694b4&scoped=true&"
import script from "./BillOfLading.vue?vue&type=script&lang=ts&"
export * from "./BillOfLading.vue?vue&type=script&lang=ts&"
import style0 from "./BillOfLading.vue?vue&type=style&index=0&id=938694b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938694b4",
  null
  
)

export default component.exports